import { render, staticRenderFns } from "./editClinicalTools.vue?vue&type=template&id=7c9f353d"
import script from "./editClinicalTools.vue?vue&type=script&lang=js"
export * from "./editClinicalTools.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports